import { styled, Dialog, DialogContent, DialogTitle } from "@mui/material";

export const Title = styled(DialogTitle)`
	text-align: center;
	font-size: 1.5em;
`;

export const UnauthorizedDialog = styled(DialogContent)`
	height: 98vh;
	/* width: clamp(200px, 600px, 100%); */
	min-width: 200px;
	width: 600px;
	max-width: 100%;
	display: flex;
	flex-direction: column;
`;

export const DialogContentCenterbody = styled("div")`
	flex-direction: column;
	justify-content: center;
	align-items: center;
	width: 100%;
	flex: 1;
	display: flex;
`;

export const BottomContent = styled("div")`
	text-align: justify;
	border-top: thin solid ${(props) => props.theme.palette.primary.main};
	padding: 1em 0em;
	font-size: 0.95em;
`;

export const ButtonContainer = styled("div")`
	width: 100%;
	display: flex;
	gap: 1em;
`;
